/* realtime/config.js -- runtime endpoint config for the realtime engine (apiUrl, ws host, websockets flag).
 * Reconstructed from lacak.io deployed behavior; app-specific contract verbatim, internal impl re-authored.
 *
 * Origin: webpack module "8514" (W["a"]() -> { websockets, apiUrl, ... }) and pro-ui/Config.js
 *   apiProfiles.japi.apiRoot '//api.lacak.io'; terminalHost 'wss://api.lacak.io/'.
 * In the assembled app this is provided by Engine A (the shared api-service/config). A self-contained
 * copy lives here so the realtime engine builds and runs in isolation. VERBATIM: the `websockets`
 * enable-gate flag and the "event/subscription" host derivation semantics.
 */

'use strict';

/* The single config object. `websockets` is the enable-gate the socket client reads before it will
 * open a connection; when false the HTTP poller fallback runs unconditionally. */
const CONFIG = {
    // REST base for Navixy API v2 JSON POSTs (request()/get_states/tracker-list).
    apiUrl: 'https://api.lacak.io/',
    // WebSocket base for the atmosphere subscription (terminalHost). atmosphere accepts ws/wss
    // directly and also rewrites http->ws internally, so either scheme resolves.
    terminalHost: 'wss://api.lacak.io/',
    // Enable-gate for the websocket leg (Object(W["a"])().websockets). Flip to false to force poller.
    websockets: true
};

/* getConfig() -- was W["a"]. Returns the live config object. */
export function getConfig() {
    return CONFIG;
}

/* setConfig(partial) -- test/boot hook to override endpoints or disable websockets. Idempotent. */
export function setConfig(partial) {
    if (partial && typeof partial === 'object') {
        for (const k in partial) {
            if (Object.prototype.hasOwnProperty.call(partial, k)) CONFIG[k] = partial[k];
        }
    }
    return CONFIG;
}

export default getConfig;
